export const SQUARESPACE_ENTERPRISE_ID = '00000000-0000-4000-8000-000000000000';

export const ENTERPRISE_CONFIG = {
  squarespace: {
    authEnterpriseIds: [SQUARESPACE_ENTERPRISE_ID],
    experienceOverrides: {},
    name: 'Squarespace',
    url: 'https://www.squarespace.com'
  }
};

/**
 * Resolves the dashboard enterprise config for an auth-provided enterprise ID.
 *
 * @param {string} enterpriseId - ZB-generated enterprise ID from auth.
 * @returns {object|null} Resolved enterprise config, or null when no config matches.
 */
export function getEnterpriseConfig(enterpriseId) {
  const enterpriseEntry = Object.entries(ENTERPRISE_CONFIG).find(
    ([, enterpriseConfig]) => enterpriseConfig.authEnterpriseIds.includes(enterpriseId)
  );

  if (!enterpriseEntry) {
    return null;
  }

  const [enterpriseKey, enterpriseConfig] = enterpriseEntry;

  return {
    id: enterpriseId,
    key: enterpriseKey,
    ...enterpriseConfig
  };
}

/**
 * Normalizes a minimal enterprise object into the matching local enterprise config.
 *
 * @param {object|null|undefined} enterprise - Enterprise object, usually containing an auth-provided id.
 * @returns {object|null} Resolved enterprise config, original enterprise object, or null.
 */
export function resolveEnterpriseConfig(enterprise) {
  if (!enterprise?.id) {
    return enterprise ?? null;
  }

  return getEnterpriseConfig(enterprise.id) ?? enterprise;
}
